import { Locales, LocaleMessages, ServerConfig } from 'shared-types';

interface Params {
  language?: Locales;
  messages: LocaleMessages;
  serverConfig: ServerConfig<'admin'>;
}

const getExcelCalendarEventsColumnOptions = ({
  language,
  messages,
  serverConfig
}: Params) => {
  const customAttributeOptions: { [key: string]: string } = {};

  serverConfig.calendarEventCustomAttributes
    ?.filter((attr) => attr.displayInAnalytics)
    .forEach((attr) => {
      customAttributeOptions[`product.customAttributes.${attr.key}`] =
        attr.titleData?.[language || serverConfig.defaultSystemLanguage] ||
        attr.title;
    });

  return {
    'product.title': messages.eventCalendarEvent,
    'product.categories': messages.commonCategories,
    'product.location': messages.commonLocation,
    'product.lastJoinDate': messages.eventCalendarJoinLastDate,
    'product.startDate': messages.commonStartDate,
    'product.endDate': messages.publishEndDate,
    'product.workloadIsEnabled': `${messages.excelWorkload} (${messages.completionWorkloadHours})`,
    ...(serverConfig.workloadInDays
      ? {
          'product.workloadInDays': `${
            messages.excelWorkload
          } (${messages.commonDays.toLowerCase()})`
        }
      : {}),
    'product.user.status': messages.commonStatus,
    'product.user.participated': messages.eventCalendarParticipantParticipated,
    'product.user.grantedAtDate': messages.excelCompletionDate,
    'product.user.participatedComment': messages.commonComment,
    ...(serverConfig.featureFlags?.enableFeedbackForCalendarEvents
      ? {
          'product.user.feedbackSubmittedAt':
            messages.excelFeedbackSubmissionDate
        }
      : {}),
    ...customAttributeOptions
  };
};

export default getExcelCalendarEventsColumnOptions;
